import styled from "styled-components";

export const TitleContainer = styled.div`
    align-items: ${props => props.$alignItems};
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: space-between;
    width: 100%;

    h1 {
        
        color: #D0D0D0;
        font-family: 'Roboto Condensed';
        font-size: 48px;
        line-height: 48px;
    }
`